import { render, staticRenderFns } from "./homeHelp.vue?vue&type=template&id=4c9e8ab1&scoped=true"
import script from "./homeHelp.vue?vue&type=script&lang=js"
export * from "./homeHelp.vue?vue&type=script&lang=js"
import style0 from "./homeHelp.vue?vue&type=style&index=0&id=4c9e8ab1&prod&lang=scss"
import style1 from "./homeHelp.vue?vue&type=style&index=1&id=4c9e8ab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9e8ab1",
  null
  
)

export default component.exports